<template>
    <div v-if="list.length" class="rounded-[16px] overflow-hidden border-slate-200 border border-solid">
        <div
            class="flex items-center justify-between bg-slate-100 p-4"
            :class="{
                'border border-t-0 border-x-0 border-solid border-slate-200': active,
            }"
        >
            <div class="flex items-center gap-2 text-sm">
                <font-awesome-icon
                    widthAuto
                    :icon="props.invalid ? faCircleX : faCircleCheck"
                    :class="[props.invalid ? 'text-rose-500' : 'text-sky-400']"
                ></font-awesome-icon>
                <div>
                    <strong class="font-bold">
                        {{ pluralized('number', list.length, true) }}
                    </strong>
                    <span class="font-normal">&nbsp;{{ props.invalid ? 'failed' : 'added successfully' }}</span>
                </div>
            </div>
            <vx-button @click="active = !active" color="muted-dark" size="sm">
                {{ active ? 'Hide' : 'View' }}
                <font-awesome-icon widthAuto :icon="active ? faCaretUp : faCaretDown"></font-awesome-icon>
            </vx-button>
        </div>
        <div v-if="active">
            <contact-phone-number-selectable-row
                v-for="contact of list"
                :key="contact.phone"
                :disabled="props.disabled"
                :contact="contact"
                :selected="true"
                @toggle="remove(contact)"
                borderBottom
            >
            </contact-phone-number-selectable-row>
        </div>
    </div>
</template>

<script setup>
import { faCaretDown, faCaretUp, faCircleCheck, faCircleX } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton } from '@voxie/frontend-components';
import { ref } from 'vue';
import { pluralized } from '~/components/filters';
import ContactPhoneNumberSelectableRow from '~/components/message-hub/message-hub-new-conversation/ContactPhoneNumberSelectableRow.vue';

const list = defineModel({
    type: Array,
    default: () => [],
    required: true,
});

const props = defineProps({
    invalid: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const active = ref(false);

const remove = async (removeItem) => {
    if (props.disabled) {
        return;
    }

    list.value = list.value.filter((item) => item.phone !== removeItem.phone);
};
</script>
